import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ErrorDialogData } from "../../core/utils/dialog.models";

@Component({
	selector: 'error-dialog',
	templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent implements OnInit {
	public title: string;
	public text: string;
	public okBtnText: string;

	public constructor(
		public dialogRef: MatDialogRef<ErrorDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ErrorDialogData
	) {}

	public ngOnInit(): void {
		this.title = this.data.title;
		this.text = this.data.text;
		this.okBtnText = this.data.okBtnText;
	}

	public onOkClick(): void {
		this.dialogRef.close({ confirm: true });
	}

	public onCancelClick(): void {
		this.dialogRef.close({ confirm: false });
	}
}
